import FormSchema from 'src/base/Form/Schemas'
import TYPES from 'src/configs/Fields'

export function buildFormSchema(dependencies) {
  const { intl } = dependencies
  const SELECT_PAYMENT_PLAN = TYPES.SELECT_PAYMENT_PLAN(intl, dependencies)

  return new FormSchema({ fieldsSchema: [ [SELECT_PAYMENT_PLAN] ]})
}
